"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressInlineErrorMessageToJSON = exports.AddressInlineErrorMessageFromJSONTyped = exports.AddressInlineErrorMessageFromJSON = void 0;
var runtime_1 = require("../runtime");
function AddressInlineErrorMessageFromJSON(json) {
    return AddressInlineErrorMessageFromJSONTyped(json, false);
}
exports.AddressInlineErrorMessageFromJSON = AddressInlineErrorMessageFromJSON;
function AddressInlineErrorMessageFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'errorInput': !(0, runtime_1.exists)(json, 'errorInput') ? undefined : json['errorInput'],
        'errorTransmitted': !(0, runtime_1.exists)(json, 'errorTransmitted') ? undefined : json['errorTransmitted'],
    };
}
exports.AddressInlineErrorMessageFromJSONTyped = AddressInlineErrorMessageFromJSONTyped;
function AddressInlineErrorMessageToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'errorInput': value.errorInput,
        'errorTransmitted': value.errorTransmitted,
    };
}
exports.AddressInlineErrorMessageToJSON = AddressInlineErrorMessageToJSON;
//# sourceMappingURL=AddressInlineErrorMessage.js.map